import {Component} from '@angular/core';
import {Account, Event} from "../../domain/models";
import {ActivatedRoute, Router} from "@angular/router";
import {OpenbandService} from "../../services/openband/openband.service";
import {NotificationService} from "../../services/notifications/notification.service";
import {Title} from "@angular/platform-browser";
import {PreferencesService} from "../../services/preferences/preferences.service";
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss']
})
export class EventsComponent {
  events: Event[] = [];
  account: Account = new Account();
  eventForm: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private api: OpenbandService,
    private notifyService: NotificationService,
    private titleService: Title,
    private prefs: PreferencesService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) {
    titleService.setTitle(`Мероприятия`)
    this.initForm();
    this.loadAccount();
    route?.queryParams?.subscribe(params => {
        var old = prefs.appPreferences
        var newToken = params['token']
        if (newToken?.length > 3) {
          old.token = newToken
          prefs.setAppPreferences(old)
          this.loadEvents()
        } else {
          this.loadEvents()
        }
      }
    )
  }

  initForm() {
    this.eventForm = this.fb.group({
      name: ['', Validators.required],
      shortName: ['', Validators.required],
      description: [''],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      location: ['trail'],
      published: [false]
    });
  }

  loadAccount() {
    this.api.getAccountSettings().subscribe(
      res => this.account = res
    )
  }

  loadEvents() {
    this.api.getEvents().subscribe(
      x => {
        this.events = x
      })
  }

  openCreateEventDialog(content) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg'
    });
  }

  onSubmit(modal) {
    if (this.eventForm.valid) {
      const event: Event = {
        ...this.eventForm.value,
        eventConfig: {
          distances: [],
          categories: [],
          bibRanges: []
        }
      };

      this.api.createEvent(event).subscribe({
        next: (response) => {
          this.toastr.success('Мероприятие успешно создано');
          this.eventForm.reset();
          modal.close();
          this.loadEvents();
        },
        error: (error) => {
          this.toastr.error('Ошибка при создании мероприятия');
          console.error('Error creating event:', error);
        }
      });
    }
  }

  generateTestData() {
    this.events.push(new Event("1", "Кросс Нации - ЗАО", true))
    this.events.push(new Event("2", "Кросс Нации - ЮВАО", true))
    this.events.push(new Event("3", "Кросс Нации - САО", true))
    this.events.push(new Event("4", "Кросс Нации - ЗелАО", true))
    this.events.push(new Event("5", "Кросс Нации - ЮЗАО", true))
  }

  parseRouteParams(params: string) {
    var splitted = params?.split(";")

  }
}
